export default {
    requestType: "Address Change",
    policyUserId: "",
    policyNumber: "",
    effectiveDate: "",
    expirationDate: "",
    firstName: "",
    middleInitial: "",
    lastName: "",
    emailAddress: "",
    policyState: "",
    newAddress: {},
    vehicles: {
        vehiclesOnPolicy: {
            storedVehicles: [],
            newVehicles: [],
            removedVehicles: []
        }
    },
    driversHHMs: {
        drivers: {
            pendingNewDrivers: [],
            pendingRemovedDrivers: [],
            storedDrivers: [],
            newDrivers: []
        },
        householdMembers: {
            pendingNewMembers: [],
            pendingRemovedMembers: [],
            storedMembers: [],
            newMembers: []
        }
    },
    driverAssignment: {},
    confirmation: false
}